import React, { useState, useEffect, Fragment } from "react";
import apiService from "../services/api.service.js";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import "../i18n/config.js";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import StorageSessionService from "../services/storage.service.js";
import CompanyProductComponent from "../components/CompanyComponents/CompanyProduct.js";
import { eventService } from "../services/event.service.js";
import { useForm } from "react-hook-form";
import ProductDescriptionComponent from "./ProductDescriptionComponent.js";
import { Link } from "react-router-dom/cjs/react-router-dom.js";
import ProductImageComponent from "./ProductImageComponent.js";
import DailyInventory from "./DailyInventoryComponents/DailyInventoryComponent.js";
import ProductPriceComponent from "./ProductPriceComponent.js";
import BookButtonComponent from "./BookButtonComponent.js";
import { useTranslation } from "../hooks/useTranslation.js";
import useMobileScreen from "./useMobileScreen";
import {sendFlashyEcommerceEvent, _ECOMMERCE_FLASHY_EVENT} from "../hooks/flashy-events"
function CurrentProductComponent(props) {
  const [product, setProduct] = useState([null]);
  const [lang, setLang] = useState("");
  const isMobile = useMobileScreen();
  const { t, translations } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const LastfreePriceChosenKey = 'LastfreePriceChosen';
  const sessionService = new StorageSessionService();
  const companyUser = useSelector((state) => state.company.companyUser)
  const company = useSelector((state) => state.company.company)

  const {
    register: dailyInventoryForm,
    formState: { errors: errorsInventoryForm },
    watch,
    getValues,
    setValue,
    setError,
    clearErrors
  } = useForm({
    defaultValues: {
      dailyInventoryQuantity: 0,
      dailyInventoryDate: null,
    },
    mode: 'all'
  });

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");

    getProducts();
    if (window.parent === window.self) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      console.info("Prod page window.parent === window.self");
    } else {
      console.info('dispatch event to scroll!');
      window.parent.postMessage({ toScroll: true }, '*');
    }
  }, []);

  useEffect(() => {
    document.title = t("PageTitleCurrentProduct");
  }, [translations]);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const getProductsFromApi = () => {
    const selectedProductId = new URLSearchParams(location.search).get("pid") || 0;
    let _properyId = null;
    if (companyUser && company) {
      apiService.getCompanyProducts(company.companyId, selectedProductId).then(
        (response) => {
          if (response.data && response.data.data) {
            setProduct(response.data.data[0]);
          } else {
            alert(t("ProductNotAvailableAnymore"));
            history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          if (_content.indexOf("401") > -1) {
            sessionStorage.removeItem("token");
          }
        }
      )
    } else {
      apiService.getProducts(chainId, _properyId, true, selectedProductId).then(
        (response) => {
          if (response.data && response.data.data && response.data.data.length) {
            setProduct(response.data.data[0]);
          } else {
            alert(t("ProductNotAvailableAnymore"));
            history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          if (_content.indexOf("401") > -1) {
            localStorage.removeItem("token");
          }
        }
      )
    }
  }
  const getProducts = () => {
    if (sessionStorage.getItem("viewProduct")) {
      let product = JSON.parse(sessionStorage.getItem("viewProduct"));
      setProduct(product);

      sessionService.getSessionStorage(LastfreePriceChosenKey).then(res => {
        let lastLastfreePriceChosen = res || null;
        if (lastLastfreePriceChosen) {
          product.productPrice = parseInt(lastLastfreePriceChosen);
          if (!product.productPrice && product.productMaximumPrice > 0 && (product.productMaximumPrice == product.productMinimumPrice)) {
            product.productPrice = product.productMaximumPrice
          }
        }
      });
      sendFlashyEcommerceEvent(_ECOMMERCE_FLASHY_EVENT.VIEW_CONTENT, [product.productId], 'flashy');
      
      eventService.viewItem(product);
    } else {
      //fetch from api
      getProductsFromApi();
    }
  };

  const getProductTranslations = (prod) => {
    if (prod && prod.translations) {
      let ProductTranslations = prod.translations.filter((p) => {
        return p.languageIsoCode == lang && p.propductId == prod.propductId;
      });
      return ProductTranslations.length > 0 ? ProductTranslations[0] : {};
    }
    return {};
  };

  const productName = (product) => {
    return getProductTranslations(product).productName ? getProductTranslations(product).productName : product.productName;
  }
  return (
    <>
      {!companyUser ?
        <div className="product-wrap">
          <Row>
            <Col>
              {!!product && (
                <div className="product box">
                  {/* daily inventory product */}
                  {!!product.enableDailyInventory ?
                    (
                      !isMobile ?
                        <Fragment>
                          <div className="top-line">
                            <span className="name"
                              role="heading"
                              aria-label={productName(product)}
                            >
                              {productName(product)}
                            </span>
                            <Link className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} aria-label={t("BackToProductsList")}>
                              {t("BackToProductsList")}
                            </Link>
                          </div>
                          <Row>
                            <Col md={5}>
                              <DailyInventory
                                watch={watch}
                                product={product}
                                setValue={setValue}
                                getValues={getValues}
                                setProduct={setProduct}
                                clearErrors={clearErrors}
                                dailyInventoryForm={dailyInventoryForm}
                                errorsInventoryForm={errorsInventoryForm}
                              />
                              <div className="bottom-sec">
                                <div className="btns-wrap">
                                  <Row className="stick-btns">
                                    <Col md={6}>
                                      <Link className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} aria-label={t("BackToProductsList")}>
                                        {t("BackToProductsList")}
                                      </Link>
                                    </Col>
                                    <BookButtonComponent
                                      lang={lang}
                                      product={product}
                                      getValues={getValues}
                                      setError={setError}
                                      errorsInventoryForm={errorsInventoryForm}
                                    />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                            <Col md={7} className="position-relative">
                              <ProductImageComponent
                                product={product}
                              />
                              <div className="mt-4">
                                <ProductDescriptionComponent
                                  product={product}
                                  getProductTranslations={getProductTranslations}
                                />
                              </div>
                            </Col>
                          </Row>
                        </Fragment>
                        :
                        <Fragment>
                          <div className="top-line">
                            <span className="name"
                              role="heading"
                              aria-label={productName(product)}
                            >
                              {productName(product)}
                            </span>
                            <Link className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} aria-label={t("BackToProductsList")}>
                              {t("BackToProductsList")}
                            </Link>
                          </div>
                          <Row>
                            <Col md={7} className="position-relative">
                              <ProductImageComponent
                                product={product}
                              />
                              <div className="mt-4">
                                <ProductDescriptionComponent
                                  product={product}
                                  getProductTranslations={getProductTranslations}
                                />
                              </div>
                            </Col>
                            <Col md={5}>
                              <DailyInventory
                                watch={watch}
                                product={product}
                                setValue={setValue}
                                getValues={getValues}
                                setProduct={setProduct}
                                clearErrors={clearErrors}
                                dailyInventoryForm={dailyInventoryForm}
                                errorsInventoryForm={errorsInventoryForm}
                              />
                              <div className="bottom-sec">
                                <div className="btns-wrap">
                                  <Row className="stick-btns">
                                    <Col md={6}>
                                      <Link className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} aria-label={t("BackToProductsList")}>
                                        {t("BackToProductsList")}
                                      </Link>
                                    </Col>
                                    <BookButtonComponent
                                      lang={lang}
                                      product={product}
                                      getValues={getValues}
                                      setError={setError}
                                      errorsInventoryForm={errorsInventoryForm}
                                    />
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Fragment>
                    ) : (
                      // regular product 
                      <Fragment>
                        <div className="top-line">
                          <span className="name"
                            role="heading"
                            aria-label={productName(product)}
                          >{productName(product)}
                          </span>
                          <span className="price hidden-mobile">
                            <ProductPriceComponent
                              product={product}
                            />
                            <BookButtonComponent
                              product={product}
                              getValues={getValues}
                              lang={lang}
                            />
                          </span>
                        </div>
                        <Row>
                          <Col md={6} className="position-relative">
                            <ProductImageComponent
                              product={product}
                            />
                          </Col>
                          <Col md={6}>
                            <ProductDescriptionComponent
                              product={product}
                              getProductTranslations={getProductTranslations}
                            />
                            <div className="bottom-sec">
                              <div className="btns-wrap">
                                <Row className="stick-btns">
                                  <Col md={6}>
                                    <Link className="btn white" to={`/?chainid=${chainId}&lang=${lang}`} aria-label={t("BackToProductsList")}>
                                      {t("BackToProductsList")}
                                    </Link>
                                  </Col>
                                  <BookButtonComponent
                                    product={product}
                                    getValues={getValues}
                                    lang={lang}
                                  />
                                </Row>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Fragment>
                    )
                  }
                </div>
              )}
            </Col>
          </Row>
        </div>
        :
        // company product 
        <div className="product-wrap">
          <div className="product box">
            <CompanyProductComponent />
          </div>
        </div>
      }
    </>
  )
}
export default CurrentProductComponent;
